import React from 'react'
import InThePressSection from './InThePressSection'

const GiftCardAppPage = () => {
    return <InThePressSection />
}

export default GiftCardAppPage
